var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-select", {
                attrs: {
                  label: "Heeft prijzenpagina bezocht",
                  items: _vm.visitedPricingPageItems,
                  fancy: "",
                },
                model: {
                  value: _vm.value.vars.visitedPricingPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.vars, "visitedPricingPage", $$v)
                  },
                  expression: "value.vars.visitedPricingPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }